import { useClickToDial } from '@/hooks/use-click-to-dial';
import { useSentryUserContext } from '@/hooks/use-sentry-user-context';

export const useSalesforceInitialization = () => {
  useSentryUserContext();
  useClickToDial();
};
